export const PERSONAL_CONTENT = {
    lessons: {
        // personal.legajos — «Personal y legajos» — roles: branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "profesores.legajos" — práctica: no
        "personal.legajos": {
            summary: "Cada persona que cobra del gimnasio tiene un legajo, y el legajo decide cuánto cobra: tipo, modalidad, sede base y categoría de tarifa. Aprendés qué datos tiene, cómo se da de alta sobre un usuario existente, por qué cada cambio pide motivo y cómo se da de baja sin borrar nada.",
            keyPoints: [
                "El legajo tiene tipo (por ejemplo profe de sala, profe de clase, recepción, encargado), modalidad (por ejemplo externo que factura), sede base, categoría de tarifa del tarifario vigente, CUIT, fecha de alta y estado. Arriba del listado, tres contadores reales del plantel te avisan si falta o sobra alguien.",
                "El alta se hace sobre alguien que ya tiene usuario en el sistema, y una persona tiene un solo legajo: si rota de sede, se edita el que existe, no se crea otro.",
                "Editar pide motivo («Guardar con motivo») y queda en el historial con usuario, motivo y el antes y el después. Lo editan Administración y los dueños; encargados y coordinación lo consultan sin botones de edición, y el historial lo leen sólo dueños y Administración.",
                "La tarifa individual (hora de sala, de clase o de clase con premio) pisa la categoría campo por campo; lo que quede vacío sigue saliendo de la categoría.",
                "La baja es con motivo: no se le arman más turnos ni se liquidan horas nuevas, las liquidaciones cerradas no se tocan y el legajo queda en la base.",
                "La habilitación para alumnos personalizados no se edita a mano: sale de la grilla publicada, con cuatro o más clases semanales. Si cambió la grilla, se toca Recalcular personalizados.",
            ],
            estimatedMin: 6,
            contentVersion: 2,
        },
        // personal.turnos — «Turnos y fichajes del equipo» — roles: branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "profesores.turnos" — práctica: no
        "personal.turnos": {
            summary: "Cómo se arma la grilla de turnos de sala y recepción y cómo el sistema cruza cada fichada contra su turno para decidir cuántas horas se pagan. Aprendés qué pasa con las llegadas tarde, las horas extra, las fichadas olvidadas y las que no tienen turno, y por qué ninguna de esas situaciones se paga ni se descuenta en silencio.",
            keyPoints: [
                "Cada persona ficha entrada y salida en la tablet de la sede, con su QR personal o su PIN, y esa fichada se cruza contra su turno. Los turnos se arman de un día o repetidos en el mes, incluido el sábado por medio (una semana sí y otra no).",
                "Dentro de la tolerancia, la hora se redondea al turno: llegar unos minutos tarde no descuenta.",
                "Fuera de la tolerancia hay discrepancia, y mientras nadie la resuelva se paga lo conservador: una hora extra se paga como turno y una fichada fuera de turno vale cero. Se resuelve contra la pre-liquidación del mes: aprobar, rechazar o ajustar minutos, siempre con motivo.",
                "Si eliminás un turno, las fichadas de ese día quedan fuera de turno y valen cero hasta que alguien las explique. No se superponen dos turnos de la misma persona.",
                "Una fichada nunca se pisa: corregir un olvido crea una entrada nueva y la original queda. Una salida olvidada se cierra sola al fin del turno y queda marcada como fichada huérfana para revisar.",
                "Los reemplazos de clase se cargan antes de liquidar: la clase la cobra quien la dictó, siempre con premio, y no mueve la vara de nadie. Con el mes cerrado, ya no se toca.",
            ],
            estimatedMin: 8,
            contentVersion: 2,
        },
        // personal.tarifario — «Tarifario y multiplicadores» — roles: branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "profesores.tarifario" — práctica: no
        "personal.tarifario": {
            summary: "De dónde sale el valor de cada hora: las categorías del tarifario (hora de sala, hora de clase y hora de clase con premio), los multiplicadores de sábado, domingo y feriado, y el calendario de feriados. Aprendés por qué el tarifario se versiona en lugar de editarse, cómo se paga un mes en el que cambió la tarifa y cómo cotizar una hora.",
            keyPoints: [
                "Cada categoría tiene hora de sala, hora de clase y hora de clase con premio; la sala se paga menos que la clase, y la hora de recepción sale del valor hora sala de la categoría de cada recepcionista.",
                "El tarifario no se edita: se publica una versión nueva con fecha de vigencia, que arranca copiando la vigente. La vigente es la de fecha más reciente que no sea futura. Lo publican Administración o los dueños; encargados y coordinación lo consultan.",
                "Cada hora se paga con la tarifa del día en que se trabajó: un cambio a mitad de mes parte la liquidación en dos tramos, solo, y lo ya liquidado no se toca.",
                "Domingo y feriado pagan doble y el sábado tiene su propio valor. No se acumulan: si un feriado cae domingo se aplica el mayor.",
                "Sin el calendario de feriados cargado, ningún día cuenta como feriado y no se paga doble. Es un solo calendario, el mismo que coordinación y encargados cargan desde la grilla del mes, y queda registrado quién cargó cada fecha.",
                "Cotizar una hora usa el mismo cálculo que la liquidación. Sin tarifario vigente el sistema no inventa un valor: avisa y no liquida esa hora.",
            ],
            estimatedMin: 7,
            contentVersion: 2,
        },
        // personal.premios — «Premios por clase» — roles: branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "profesores.varas" — práctica: no
        "personal.premios": {
            summary: "Cómo funciona el premio de los profes de clase con la vara móvil: el piso de presentes que hay que igualar o superar para que esa hora se pague con premio. Aprendés cómo se calcula la vara con el promedio del mes, cuándo sube, qué pasa con los reemplazos y las clases nuevas, y cuándo y cómo se ajusta a mano.",
            keyPoints: [
                "La vara es el promedio de presentes que tuvo esa clase en el mes anterior. Una clase sale con premio cuando sus presentes igualan o superan la vara; cuentan los presentes, no las reservas.",
                "La vara es de cada clase de la grilla: profesor, disciplina, sede, día y hora. La clase de lunes 8:00 y la de miércoles 19:00 del mismo profe tienen varas distintas, y la misma clase en dos sedes también.",
                "Al cerrar el mes se promedian los presentes de las clases que se dictaron (las suspendidas y las que quedaron a confirmar no cuentan). Si el promedio supera la vara, la vara del mes siguiente pasa a ese promedio (redondeado hacia abajo, salvo que se cambie el parámetro). Ejemplo: vara 6 y presentes 8, 10, 12, 6 y 4 → salen con premio las cuatro primeras y el mes siguiente la vara es 8. La tabla muestra el promedio en curso y la vara del mes que viene.",
                "«Sin vara» es el primer mes de una clase: no hay con qué comparar, así que no hay premio; al cerrar el mes, su vara arranca en el promedio. Sin vara no es lo mismo que vara cero.",
                "La vara nunca baja sola: si la clase pasa a un salón más chico, se ajusta con motivo, rige desde el mes en curso y queda en el historial con tu nombre. El profe la ve en su portal pero no la cambia.",
                "El reemplazo cobra siempre con premio y no mueve la vara de nadie, las clases master no forman serie regular y el premio se evalúa clase por clase.",
            ],
            estimatedMin: 8,
            contentVersion: 3,
        },
        // personal.objetivos — «Objetivos y comisiones de recepción» — roles: branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "profesores.objetivos" — práctica: no
        "personal.objetivos": {
            summary: "Cómo se fija el objetivo mensual de venta de planes de cada recepcionista y cómo se calcula su comisión con los cobros reales. Aprendés a quién se le atribuye cada venta, qué ventas quedan afuera y cómo se reasigna una venta mal atribuida.",
            keyPoints: [
                "A principio de mes Administración o los dueños fijan el objetivo de cada recepcionista; pasado el día tope (por defecto el cinco) el sistema pide motivo y queda auditado.",
                "La tabla del mes muestra objetivo, ventas atribuidas, porcentaje alcanzado, tramo de la escala y comisión. «Sin objetivo» quiere decir que nadie fijó la meta, no que la persona lleve 0 %.",
                "Cada objetivo guarda su copia de la escala: si la escala cambia después, no reescribe la comisión de los meses anteriores. La escala se edita en Configuración → Parámetros.",
                "Las ventas atribuidas salen de los cobros reales. La comisión sigue al vendedor, no a la caja: la cuota de un plan largo suma a quien lo vendió aunque se pague en otra sede.",
                "Una venta que quedó a nombre de quien cobró pero la vendió otra se reasigna con motivo y queda en Reasignaciones del mes. Las ventas 100 % online desde la app no son de nadie y no comisionan; si una recepcionista rota de sede, sus ventas viajan con ella.",
                "Encargados y coordinación ven todo pero no fijan objetivos ni reasignan. Cada recepcionista ve su avance en vivo en «Mis comisiones».",
            ],
            estimatedMin: 7,
            contentVersion: 2,
        },
        // personal.liquidacion — «La liquidación del mes, de la pre-liquidación al cierre» — roles: branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "profesores.preliquidacion" — práctica: sí
        "personal.liquidacion": {
            summary: "El circuito de la liquidación mensual: el sistema calcula todo el mes solo, el encargado revisa y ajusta con motivo, y Administración cierra. Aprendés a leer la pre-liquidación de cada persona y su semáforo de pendientes, y por qué una liquidación cerrada no se reabre nunca.",
            keyPoints: [
                "El día 1 se arma sola la pre-liquidación de cada persona: horas, premios, pruebas convertidas, comisiones y ajustes. Cada renglón guarda lo que regía ese día (presentes, vara, tarifa y multiplicador).",
                "Mirá primero el semáforo, antes que el total: clases a confirmar (cero presentes que el profe todavía no marcó como dictadas), discrepancias de fichaje y facturas de externos pendientes.",
                "Un renglón mal se ajusta con motivo: el ajuste no borra el original y sobrevive a Recalcular el mes. Lo que el sistema no puede saber, como una hora acordada aparte, va con Agregar renglón y motivo.",
                "Paso 1: el encargado (o coordinación) revisa su sede. Paso 2: Administración o los dueños cierran; se puede cerrar con pendientes, pero quedan así para siempre.",
                "Al cerrar queda inmutable y aparece en el portal del profesional. Para un externo se crea el egreso pendiente en Contable y se marca Factura recibida cuando llega; para relación de dependencia se exporta el detalle al estudio contable.",
                "Cerrada no se reabre: un error posterior va como ajuste retroactivo (positivo o negativo, con motivo) que se arrastra al mes siguiente. Si faltan horas, revisá turnos, fichadas y reemplazos y después Recalcular el mes.",
            ],
            estimatedMin: 10,
            contentVersion: 2,
        },
    },
    questions: [
        // ── personal.legajos ────────────────────────────────────────────────────
        {
            id: "personal.legajos#1",
            lessonKey: "personal.legajos",
            prompt: "Una profe que trabajaba en Olivos pasa a dar clases en Martínez. ¿Qué hacés con su legajo?",
            options: [
                {
                    id: "a",
                    text: "Creás un legajo nuevo para Martínez y dejás el de Olivos activo para las horas viejas.",
                },
                { id: "b", text: "Das de baja el de Olivos y creás uno nuevo en Martínez." },
                { id: "c", text: "Editás el legajo que existe, cambiás la sede y escribís el motivo." },
                { id: "d", text: "Le cargás una tarifa individual con la sede nueva." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, si alguien rota de sede no se crea otro legajo: se edita el que existe, y sin motivo no se guarda. Una persona tiene un solo legajo.",
        },
        {
            id: "personal.legajos#2",
            lessonKey: "personal.legajos",
            prompt: "Un profe cobra la hora de clase distinta que el resto de su categoría, pero la hora de sala igual. ¿Cómo se carga?",
            options: [
                {
                    id: "a",
                    text: "Con una tarifa individual sólo en hora de clase.",
                },
                { id: "b", text: "Creando una categoría nueva sólo para él en el legajo." },
                {
                    id: "c",
                    text: "Cargando los tres valores en la tarifa individual, aunque sean iguales.",
                },
                { id: "d", text: "Ajustando a mano cada liquidación del mes." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, la tarifa individual pisa la categoría campo por campo; lo que dejes vacío sigue saliendo de la categoría.",
        },
        {
            id: "personal.legajos#3",
            lessonKey: "personal.legajos",
            prompt: "Una recepcionista deja de trabajar en el gimnasio. ¿Qué pasa cuando le das de baja el legajo?",
            options: [
                { id: "a", text: "Se borra el legajo y sus liquidaciones." },
                { id: "b", text: "Se reabren sus liquidaciones cerradas para el pago final." },
                { id: "c", text: "Se le borra el usuario del sistema." },
                {
                    id: "d",
                    text: "No se le arman turnos ni horas nuevas, y el legajo queda.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, la baja lleva motivo: no se le arman más turnos ni se le liquidan horas nuevas, las liquidaciones cerradas no se tocan y nada se borra.",
        },
        {
            id: "personal.legajos#4",
            lessonKey: "personal.legajos",
            prompt: "Un profe empezó a dar cinco clases semanales en la grilla publicada y en su legajo no figura habilitado para alumnos personalizados. ¿Qué hacés?",
            options: [
                { id: "a", text: "Lo tildás a mano en su legajo con motivo." },
                { id: "b", text: "Tocás Recalcular personalizados." },
                { id: "c", text: "Le creás un legajo nuevo de tipo personal trainer." },
                { id: "d", text: "Esperás a que él lo pida desde su portal." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, la habilitación para personalizados no se edita a mano: sale de la grilla publicada con cuatro o más clases semanales, y si cambió la grilla se toca Recalcular personalizados.",
        },
        // ── personal.turnos ─────────────────────────────────────────────────────
        {
            id: "personal.turnos#1",
            lessonKey: "personal.turnos",
            prompt: "Una profe de sala llegó cuatro minutos tarde, dentro de la tolerancia. ¿Cómo se computa esa hora?",
            options: [
                { id: "a", text: "Se le descuentan los cuatro minutos." },
                { id: "b", text: "Se redondea al turno: no se le descuenta nada." },
                { id: "c", text: "Queda como discrepancia hasta que el encargado la resuelva." },
                { id: "d", text: "Vale cero hasta que alguien la explique." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, dentro de la tolerancia la hora se redondea al turno: llegar unos minutos tarde no descuenta. Recién fuera de la tolerancia hay discrepancia.",
        },
        {
            id: "personal.turnos#2",
            lessonKey: "personal.turnos",
            prompt: "Un profe se quedó una hora más cubriendo a una compañera y nadie resolvió todavía la discrepancia. ¿Cómo se paga mientras tanto?",
            options: [
                { id: "a", text: "Como turno: se computa lo conservador." },
                { id: "b", text: "Lo trabajado, con la hora extra incluida." },
                { id: "c", text: "Cero: todo el día queda sin pagar." },
                { id: "d", text: "Doble, porque es hora extra." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, una discrepancia no se liquida sola: mientras nadie la resuelva se computa lo conservador, y una hora extra se paga como turno. Para pagarla se resuelve con «aprobar lo trabajado» y motivo.",
        },
        {
            id: "personal.turnos#3",
            lessonKey: "personal.turnos",
            prompt: "Eliminaste por error el turno del martes de una recepcionista que ese día fichó normalmente. ¿Qué pasa con sus fichadas?",
            options: [
                { id: "a", text: "Se borran junto con el turno." },
                { id: "b", text: "Se pagan igual, como si el turno existiera." },
                { id: "c", text: "Quedan fuera de turno y valen cero." },
                { id: "d", text: "Se pasan solas al turno del miércoles." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, si eliminás un turno, las fichadas de ese día quedan fuera de turno y valen cero hasta que alguien las explique.",
        },
        {
            id: "personal.turnos#4",
            lessonKey: "personal.turnos",
            prompt: "El titular de funcional faltó y la clase la dio otro profe. ¿Qué tenés que hacer y cuándo?",
            options: [
                { id: "a", text: "Nada: el sistema lo detecta solo por la asistencia." },
                { id: "b", text: "Ajustar a mano la liquidación del titular después de cerrar el mes." },
                { id: "c", text: "Pedirle al profe que lo cargue desde su portal." },
                {
                    id: "d",
                    text: "Cargar el reemplazo con motivo, antes de liquidar.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, con Cargar reemplazo de clase elegís la clase y quién la dictó, con motivo, y se hace antes de liquidar. La clase la cobra quien la dio, no el titular, siempre con premio y sin mover la vara de nadie.",
        },
        // ── personal.tarifario ──────────────────────────────────────────────────
        {
            id: "personal.tarifario#1",
            lessonKey: "personal.tarifario",
            prompt: "Un profe dio una clase un feriado que cayó domingo. ¿Cómo se aplican los multiplicadores?",
            options: [
                { id: "a", text: "Se acumulan: cobra cuádruple." },
                { id: "b", text: "No se acumulan: se aplica el mayor, así que cobra doble." },
                {
                    id: "c",
                    text: "Se aplica sólo el de domingo, porque el feriado no cuenta en fin de semana.",
                },
                { id: "d", text: "Cobra la hora simple, porque los multiplicadores no se combinan." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, domingo y feriado pagan doble y los multiplicadores no se acumulan: un feriado que cae domingo paga doble, no cuádruple. Se aplica el mayor.",
        },
        {
            id: "personal.tarifario#2",
            lessonKey: "personal.tarifario",
            prompt: "Se publica un aumento con vigencia desde el 15 de noviembre. ¿Cómo se liquida noviembre?",
            options: [
                { id: "a", text: "Todo el mes con la tarifa nueva." },
                { id: "b", text: "Todo el mes con la tarifa vieja, y el aumento desde diciembre." },
                {
                    id: "c",
                    text: "En dos tramos: antes, tarifa vieja; después, la nueva.",
                },
                { id: "d", text: "Con un promedio de las dos tarifas." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, cada hora se paga a la tarifa del día en que se trabajó, y si la nueva arranca a mitad de mes la liquidación se parte en dos tramos de forma automática.",
        },
        {
            id: "personal.tarifario#3",
            lessonKey: "personal.tarifario",
            prompt: "Se cargó mal el valor de una categoría en la versión vigente del tarifario. ¿Cómo se corrige?",
            options: [
                { id: "a", text: "Publicando una versión nueva." },
                { id: "b", text: "Editando la versión vigente con motivo." },
                { id: "c", text: "Borrando la versión y cargándola de nuevo." },
                { id: "d", text: "Creando una categoría con el mismo código y el valor correcto." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, ninguna versión se edita después de publicada: se publica otra con su fecha de vigencia. Y no puede haber dos categorías con el mismo código.",
        },
        {
            id: "personal.tarifario#4",
            lessonKey: "personal.tarifario",
            prompt: "Un profe trabajó el 20 de noviembre, feriado, pero en la liquidación no le salió doble. ¿Qué es lo primero que revisás?",
            options: [
                { id: "a", text: "Que el profe haya fichado con su QR y no con PIN." },
                {
                    id: "b",
                    text: "Que el tarifario tenga una categoría «feriado» asignada en el legajo del profe.",
                },
                { id: "c", text: "Que la clase tenga premio." },
                { id: "d", text: "Que la fecha esté cargada en el calendario de feriados." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, sin el calendario de feriados cargado ningún día cuenta como feriado y no se paga doble. Es el mismo calendario que se carga desde la grilla del mes.",
        },
        // ── personal.premios ────────────────────────────────────────────────────
        {
            id: "personal.premios#1",
            lessonKey: "personal.premios",
            prompt: "La clase de lunes 8:00 tiene vara 6. En el mes tuvo 8, 10, 12, 6 y 4 presentes. ¿Qué pasa?",
            options: [
                {
                    id: "a",
                    text: "Salen con premio las cuatro primeras y, como el promedio es 8, el mes siguiente la vara es 8.",
                },
                {
                    id: "b",
                    text: "Salen con premio todas, y el mes siguiente la vara es 12, la mejor clase.",
                },
                {
                    id: "c",
                    text: "Sale con premio sólo la de 12, porque es la única que supera por mucho.",
                },
                { id: "d", text: "Como una clase tuvo 4, la vara baja a 4 el mes siguiente." },
            ],
            correctOptionId: "a",
            explanation: "La vara es el piso de presentes: sale con premio cada clase que la iguala o la supera (8, 10, 12 y 6), y la de 4 no. Al cerrar el mes se promedian las clases dictadas: (8+10+12+6+4)/5 = 8, que supera 6, así que la vara del mes siguiente es 8. La vara nunca baja sola.",
        },
        {
            id: "personal.premios#2",
            lessonKey: "personal.premios",
            prompt: "Un profe da funcional en Olivos los lunes a las 8:00 y los miércoles a las 19:00. ¿Cuántas varas tiene?",
            options: [
                { id: "a", text: "Una sola, porque es la misma disciplina en la misma sede." },
                { id: "b", text: "Una sola, la del horario donde tiene más alumnos." },
                { id: "c", text: "Dos: una por cada clase de la grilla." },
                { id: "d", text: "Ninguna: las varas son por salón, no por profe." },
            ],
            correctOptionId: "c",
            explanation: "Cada vara es de una clase de la grilla: profesor, disciplina, sede, día y hora. La clase de lunes 8:00 y la de miércoles 19:00 tienen varas distintas, y cada una se mide con su propio promedio.",
        },
        {
            id: "personal.premios#3",
            lessonKey: "personal.premios",
            prompt: "Una clase se mudó a un salón más chico y ya no puede llegar a su vara. ¿Qué hacés?",
            options: [
                { id: "a", text: "Esperás: la vara baja sola al mes siguiente." },
                { id: "b", text: "Le pedís al profe que la ajuste desde su portal." },
                { id: "c", text: "Ponés la vara en cero para que todas las clases salgan con premio." },
                {
                    id: "d",
                    text: "Ajustás la vara con motivo: rige desde el mes en curso.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, la vara nunca baja sola: bajarla es una decisión humana con motivo, rige desde el mes en curso y queda en el historial con tu nombre. El profe la ve pero no la cambia.",
        },
        {
            id: "personal.premios#4",
            lessonKey: "personal.premios",
            prompt: "Una clase nueva dice «sin vara». ¿Qué pasa con el premio ese mes?",
            options: [
                { id: "a", text: "Todas sus clases salen con premio, porque la vara es cero." },
                { id: "b", text: "No hay premio: no hay con qué comparar." },
                { id: "c", text: "Se toma la vara de otra clase del mismo profe." },
                { id: "d", text: "Se le asigna la vara de la disciplina." },
            ],
            correctOptionId: "b",
            explanation: "«Sin vara» es el primer mes de una clase: no hay con qué comparar, así que ese mes no hay premio; al cerrar el mes, la vara arranca en su promedio de presentes. Sin vara no es lo mismo que vara cero.",
        },
        // ── personal.objetivos ──────────────────────────────────────────────────
        {
            id: "personal.objetivos#1",
            lessonKey: "personal.objetivos",
            prompt: "En la tabla del mes, una recepcionista aparece «sin objetivo». ¿Cómo lo leés?",
            options: [
                { id: "a", text: "Que lleva 0 % del objetivo." },
                { id: "b", text: "Que no vendió ningún plan." },
                { id: "c", text: "Que ya cobró la comisión del mes." },
                { id: "d", text: "Que nadie le fijó la meta." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, «sin objetivo» quiere decir que nadie fijó la meta, no que la persona lleve cero por ciento. Sin objetivo no hay porcentaje.",
        },
        {
            id: "personal.objetivos#2",
            lessonKey: "personal.objetivos",
            prompt: "Una socia compró un plan anual con Laura en Olivos, y la cuota de este mes la pagó en Martínez. ¿A quién suma?",
            options: [
                { id: "a", text: "A Laura, que vendió el plan." },
                { id: "b", text: "A la recepcionista de Martínez que cobró." },
                { id: "c", text: "Se reparte entre las dos." },
                { id: "d", text: "A nadie, porque se pagó en otra sede." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, la comisión sigue al vendedor, no a la caja: la cuota de un plan largo suma a quien lo vendió, aunque se pague en otra sede.",
        },
        {
            id: "personal.objetivos#3",
            lessonKey: "personal.objetivos",
            prompt: "Es 12 del mes y Administración tiene que cambiar el objetivo de una recepcionista. ¿Qué pasa?",
            options: [
                { id: "a", text: "No se puede: el objetivo sólo se fija hasta el día 5." },
                { id: "b", text: "Se cambia sin más, como a principio de mes." },
                { id: "c", text: "Se puede, pero pide motivo y queda auditado." },
                { id: "d", text: "Lo cambia el encargado de la sede." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, pasado el día tope del mes, que por defecto es el cinco, el sistema pide motivo para fijar el objetivo y queda auditado. Encargados y coordinación no fijan objetivos.",
        },
        {
            id: "personal.objetivos#4",
            lessonKey: "personal.objetivos",
            prompt: "Un socio se dio de alta y pagó todo desde la app, sin pasar por recepción. ¿A quién se le atribuye la venta?",
            options: [
                { id: "a", text: "A la recepcionista del turno en que pagó." },
                { id: "b", text: "A nadie: las ventas 100 % online no comisionan." },
                {
                    id: "c",
                    text: "A la recepcionista con menos ventas del mes, para equilibrar las comisiones.",
                },
                { id: "d", text: "Al encargado de la sede." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, las ventas cien por ciento online desde la app quedan sin atribución: no son de nadie y no comisionan.",
        },
        // ── personal.liquidacion ────────────────────────────────────────────────
        {
            id: "personal.liquidacion#1",
            lessonKey: "personal.liquidacion",
            prompt: "Después de cerrar octubre aparece que a un profe le faltó pagar una clase. ¿Cómo se corrige?",
            options: [
                { id: "a", text: "Se reabre la liquidación de octubre y se agrega el renglón." },
                { id: "b", text: "Se le paga en efectivo por fuera del sistema." },
                { id: "c", text: "Se edita el total de la liquidación cerrada con motivo." },
                {
                    id: "d",
                    text: "Con un ajuste retroactivo que se arrastra a noviembre.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, una liquidación cerrada no se reabre: no existe ese botón. Se abre la cerrada y se toca Ajuste retroactivo, con importe y motivo, y se arrastra al mes siguiente.",
        },
        {
            id: "personal.liquidacion#2",
            lessonKey: "personal.liquidacion",
            prompt: "Sos encargado de sede y terminaste de revisar las pre-liquidaciones de tu sede. ¿Qué te toca a vos?",
            options: [
                { id: "a", text: "Tocar Revisar; la cierra Administración." },
                { id: "b", text: "Cerrarlas, para que el equipo cobre." },
                { id: "c", text: "Exportarlas y mandarlas al estudio contable." },
                { id: "d", text: "Nada: se cierran solas el día 10." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, son dos pasos y dos roles: el encargado (o coordinación) revisa y la marca como revisada, y Administración o los dueños la cierran.",
        },
        {
            id: "personal.liquidacion#3",
            lessonKey: "personal.liquidacion",
            prompt: "Un renglón de un profe está mal y lo ajustás con motivo. Después alguien toca Recalcular el mes. ¿Qué pasa con tu ajuste?",
            options: [
                { id: "a", text: "Se pierde: el recálculo vuelve todo a lo que calcula el sistema." },
                { id: "b", text: "Sobrevive: el recálculo no pierde los ajustes." },
                { id: "c", text: "Queda pendiente de aprobación otra vez." },
                { id: "d", text: "Se convierte en un ajuste retroactivo del mes siguiente." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, el ajuste no borra el original y sobrevive si se recalcula el mes: Recalcular vuelve a calcular las abiertas sin perder los ajustes cargados.",
        },
        {
            id: "personal.liquidacion#4",
            lessonKey: "personal.liquidacion",
            prompt: "A una profe le faltan horas en la pre-liquidación. ¿Qué revisás primero?",
            options: [
                { id: "a", text: "Le agregás un renglón con las horas que dice que trabajó." },
                { id: "b", text: "La cerrás igual y lo corregís con un ajuste retroactivo." },
                {
                    id: "c",
                    text: "Turnos, fichadas y reemplazos; después Recalcular el mes.",
                },
                { id: "d", text: "Le pedís que vuelva a fichar esos días." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, si a alguien le faltan horas, revisás primero sus turnos y fichadas y que los reemplazos estén cargados, y después tocás Recalcular el mes.",
        },
    ],
};
//# sourceMappingURL=personal.js.map